export default {
  "content": "<path d=\"M5.306 9.143l4.25-7 4.25 7h-8.5zm8.75 9c-.972 0-1.799-.34-2.48-1.021-.68-.68-1.02-1.507-1.02-2.48 0-.971.34-1.798 1.02-2.478.681-.68 1.508-1.021 2.48-1.021s1.799.34 2.48 1.02c.68.681 1.02 1.508 1.02 2.48s-.34 1.798-1.02 2.479c-.682.68-1.508 1.02-2.48 1.02zm-11.5-.5v-6h6v6h-6zm11.495-1c.559 0 1.033-.193 1.422-.579.388-.386.583-.858.583-1.416 0-.56-.193-1.033-.579-1.422a1.919 1.919 0 00-1.416-.583c-.56 0-1.033.193-1.422.579a1.919 1.919 0 00-.583 1.416c0 .559.193 1.033.579 1.421.385.39.857.584 1.416.584zm-9.995-.5h3v-3h-3v3zm3.917-8.5h3.166L9.556 5.039 7.973 7.643z\" fill=\"#656A81\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};